module.exports = __webpack_public_path__ + "static/media/15e-03_ST-12-2015-1829x1372mm-oleo-sobre-madera.3ad63158.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15e/15e-03_ST-12-2015-1829x1372mm-oleo-sobre-madera.jpg
// module id = 172
// module chunks = 0